import { getExtFile } from './get-ext-file';

export const prepareDataPicture = (data = []) => {
  const imagesTypes = ['jpg', 'jpeg', 'png', 'webp'];
  const result = { '1x': [] };
  const links = [];

  if (!Array.isArray(data)) {
    return result;
  }

  data.forEach((item) => {
    const ext = getExtFile(item);

    if (imagesTypes.includes(ext)) {
      links.push(item);
    }
  });

  result['1x'] = links;

  return result;
};
